module.exports = __webpack_public_path__ + "media/react/gre/adaptive_prep_v2/assets/lock_icon-5f971a7f28d02aa1f1b4bd22c58d3f1b.svg";